import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
import { getLocalStorageValue } from "../../utils/localStorage";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DashboardLayout from "../../components/global/DashboardLayout";
import DashboardHeader from "../../components/global/DashboardHeader";
import DashboardFirstRow from "../../components/dashboard/DashboardFirstRow";
import DashboardSecondRow from "../../components/dashboard/DashboardSecondRow";
import DashboardThirdRow from "../../components/dashboard/DashboardThirdRow";
import ActionButton from "../../components/shared/ActionButton";

const Dashboard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    const result = getLocalStorageValue("admin");
    if (!result) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <DashboardLayout>
      <Box m="20px">
        <Box display="flex" justifyContent="end">
          <ActionButton
            colors={colors}
            title="Download Reports"
            icon={<DownloadOutlinedIcon />}
          />
        </Box>

        <DashboardHeader
          title="Dashboard"
          subtitle="Welcome to your dashboard"
        />

        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="140px"
          gap="20px"
        >
          <DashboardFirstRow colors={colors} />

          <DashboardSecondRow colors={colors} />

          <DashboardThirdRow colors={colors} />
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Dashboard;
